import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NotificationService} from '../../../services/notification.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {Location} from '@angular/common';
import {UserDTO} from '../../../model/userDTO';
import {ConfirmDTO} from '../../shared/notification/ConfirmDTO';

@Component({templateUrl: './edit-second-user.component.html'})
export class EditSecondUserComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  clientId: number;
  user: UserDTO;
  isLoading: boolean;

  constructor(private builder: FormBuilder,
              private service: UserService,
              private notificationService: NotificationService,
              private router: Router,
              private _location: Location,
              private route: ActivatedRoute) {
  }

  get f() {
    return this.form.controls;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.clientId = params['clientId'];
      this.service.getSecondUser(this.clientId).subscribe(user => {
        this.user = user;
        this.form = this.getForm();
      });
    });
  }

  submit(value) {
    this.submitted = true;
    if (this.form.invalid || this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.service.editSecondUser(this.clientId, value).subscribe(() => {
        this.notificationService.success('tweede bewindvoerder opgeslagen');
        this.back();
      }, error => this.notificationService.errorResponse(error),
      () => this.isLoading = false);
  }

  back() {
    this._location.back();
  }

  removeSecondUser() {
    const data: ConfirmDTO = {header: 'tweede bewindvoerder verwijderen?', ok: 'verwijderen'};
    this.notificationService.confirm(data).then(() => this.service.removeSecondUser(this.clientId).subscribe(() => {
       this.notificationService.success('tweede bewindvoerder verwijderd');
       this.back();
    }));
  }

  private getForm() {
    return this.builder.group({
      'showEmailOnReports': [this.user.showEmailOnReports],
      'firstNameInitials': [this.user.firstNameInitials, [Validators.required, Validators.maxLength(255)]],
      'firstName': [this.user.firstName, [Validators.required, Validators.maxLength(255)]],
      'insertion': [this.user.insertion, [Validators.maxLength(255)]],
      'lastName': [this.user.lastName, [Validators.required, Validators.maxLength(255)]],
      'street': [this.user.street, [Validators.required, Validators.maxLength(255)]],
      'houseNumber': [this.user.houseNumber, [Validators.required, Validators.maxLength(255)]],
      'houseNumberSuffix': [this.user.houseNumberSuffix, [Validators.maxLength(255)]],
      'zipCode': [this.user.zipCode, [Validators.required, Validators.maxLength(255)]],
      'city': [this.user.city, [Validators.required, Validators.maxLength(255)]],
      'phone': [this.user.phone, [Validators.required, Validators.maxLength(255)]],
    });
  }
}
